import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { hasOrg } from './auth/session';
import { RequireAuth } from './auth/RequireAuth';
import { Login } from './routes/Login';
import { Registro } from './routes/Registro';
import { Recuperar } from './routes/Recuperar';
import { RecuperarReset } from './routes/RecuperarReset';
import { Invitacion } from './routes/Invitacion';
import { Unirse } from './routes/Unirse';
import { BusinessArea } from './routes/BusinessArea';
import { ClientArea } from './routes/ClientArea';
import { KitchenSink } from './routes/KitchenSink';
import { Landing } from './routes/publico/Landing';
import { Precios } from './routes/publico/Precios';

function Protected() {
  const { session } = useAuth();
  if (!hasOrg(session)) return <Navigate to="/unirse" replace />;
  return session?.roleKind === 'client' ? <ClientArea /> : <BusinessArea />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/precios" element={<Precios />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/recuperar" element={<Recuperar />} />
      <Route path="/recuperar/reset" element={<RecuperarReset />} />
      <Route path="/i/:code" element={<Invitacion />} />
      <Route path="/unirse" element={<RequireAuth><Unirse /></RequireAuth>} />
      <Route path="/app/*" element={<RequireAuth><Protected /></RequireAuth>} />
      <Route path="/dev/kitchen-sink" element={<KitchenSink />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
